import React from 'react';

const WidgetTabsLabel: React.FC = ({ children }) => {
    return <>{children}</>;
};

export default WidgetTabsLabel;
